
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import Testimonials from './TestimonialKeyword';
import Accordion from './Accordion';

function Alanditomumbaicabservice() {



    const cardData =
    {
        keyword: 'Alandi to Mumbai Cabs Service',
        heading: 'Meghana Cab : Alandi to Mumbai Cabs Service',
        headingDescription: 'Meghana Cab offers Alandi to Mumbai Cabs Service, providing a smooth, safe, and comfortable travel experience from the spiritual town of Alandi to the bustling city of Mumbai. Whether you are planning a pilgrimage extension, business trip, airport transfer, or a family outing, our fleet of well-maintained Hatchbacks, Sedans, SUVs, and Innova Crysta ensures a hassle-free ride. Enjoy doorstep pickup from Alandi, experienced drivers, on-time service, transparent pricing, and 24/7 customer support. Book your Alandi to Mumbai Cab with Meghana Cab and experience reliable intercity travel with complete peace of mind.',


        top: 'Top Places to Visit in Mumbai with Meghana Cab',

      "topPlaces": [ 
 
   {
    "title": "Elephanta Caves",
    "description": "Located 11 km offshore on Elephanta Island, these 5th-to-8th-century rock-cut caves are a UNESCO World Heritage Site showcasing ancient Indian art dedicated primarily to Lord Shiva. The highlight is the massive Trimurti sculpture—depicting the three aspects of Shiva—carved into a single rock face. The island offers not just religious and artistic significance but also scenic views, lush trails, and a tranquil ferry ride from the Gateway of India, making it a full-day cultural and nature getaway from Mumbai's bustle."
  },
  {
    "title": "Gateway of India",
    "description": "The Gateway of India stands as Mumbai’s most enduring symbol, built in 1924 to commemorate the visit of King George V and Queen Mary. Overlooking the Arabian Sea, this colossal basalt arch marks the point from which the last British troops left India, making it both a historical and emotional landmark. Located in Apollo Bunder, it serves as a hub for ferry rides to Elephanta Island and provides stunning views at sunrise and sunset. The Indo-Saracenic style architecture and its vibrant surroundings filled with street vendors, photographers, and tourists make it a dynamic cultural hub."
  },
   {
    "title": "Siddhivinayak Temple",
    "description": "One of the richest and most visited temples in Mumbai, Siddhivinayak is dedicated to Lord Ganesha, the remover of obstacles. Originally built in 1801, it features a gold-plated inner sanctum and a unique idol carved from a single black stone, with the trunk curving to the right. The temple draws politicians, Bollywood celebrities, and millions of devotees annually, especially on Tuesdays when the lines stretch for hours. Despite the crowds, the spiritual atmosphere and meticulous organization make it a peaceful yet powerful experience."
  },
  {
    "title": "Marine Drive & Girgaon Chowpatty",
    "description": "Stretching 3.6 kilometers along the Arabian Sea, Marine Drive is Mumbai’s iconic palm-lined promenade shaped like a necklace, earning it the nickname 'Queen’s Necklace.' It’s a favorite spot for joggers, lovers, and tourists who gather to admire the sea view and city skyline, especially at sunset. At the northern end lies Girgaon Chowpatty, a lively beach known for its street food—bhel puri, pav bhaji, gola—and as a venue for the grand Ganesh Visarjan immersions. The entire stretch embodies Mumbai’s coastal spirit and urban pulse."
  },
  {
    "title": "Chhatrapati Shivaji Maharaj Terminus (CST)",
    "description": "A masterpiece of Victorian Gothic Revival architecture fused with Indian design, CST (formerly Victoria Terminus) is a UNESCO World Heritage Site and one of India’s busiest railway stations. Constructed in 1887, the terminus features turrets, pointed arches, domes, stained-glass windows, and intricate carvings of animals and deities. It stands as a testament to colonial-era craftsmanship while functioning as a modern-day transport lifeline for over 3 million daily commuters. Its majestic façade is especially breathtaking when illuminated at night."
  },
  {
    "title": "Haji Ali Dargah",
    "description": "Built in 1431 in honor of the Sufi saint Haji Ali, this Indo-Islamic marble dargah sits on a tiny islet 500 meters off the coast, connected by a narrow causeway that floods during high tide. It is visited by people of all religions and backgrounds, symbolizing Mumbai’s spiritual inclusiveness. With white domes, intricate mirror work, and prayers echoing against sea winds, it offers both a religious and atmospheric experience. The view of the Mumbai skyline from the dargah adds a contemplative beauty to the site."
  },
  {
    "title": "Chhatrapati Shivaji Maharaj Vastu Sangrahalaya (Prince of Wales Museum)",
    "description": "Housed in a grand Indo-Saracenic building amidst lush gardens, this museum features over 50,000 artifacts from ancient to modern India. Its galleries cover art, archaeology, armory, numismatics, and decorative arts, including standout collections of miniature paintings, Buddhist sculptures, Mughal weaponry, and European antiques. The museum offers guided tours, audio guides, and children's workshops, making it both educational and engaging for visitors of all ages. Its architectural grandeur and curated exhibits make it one of India’s finest museums."
  },
  {
    "title": "Colaba Causeway",
    "description": "A vibrant shopping and cultural district near the Gateway of India, Colaba Causeway offers a sensory overload of colors, sounds, and flavors. Street stalls sell everything from junk jewelry and antiques to clothing and souvenirs, while iconic cafés like Leopold and Café Mondegar cater to tourists and locals alike. It’s the perfect place to experience Mumbai’s cosmopolitan vibe, blending colonial architecture with contemporary fashion, street food, and bustling life from early morning until late night."
  },
  {
    "title": "Juhu Beach",
    "description": "Juhu Beach is one of Mumbai’s most popular coastal stretches, offering a blend of natural beauty, local flavors, and a touch of celebrity culture. Frequented by locals for evening walks, kite flying, and beachside yoga, the beach is also known for its chaat stalls, pony rides, and occasional film shoots. It's common to spot Bollywood stars residing nearby. The beach also hosts cultural festivals and public events, making it more than just a leisure destination—it’s a slice of Mumbai’s identity."
  },
  {
    "title": "Sanjay Gandhi National Park & Kanheri Caves",
    "description": "This 87-square-kilometer green oasis within city limits offers a rare mix of wildlife sanctuary, recreational space, and ancient history. The park houses deer, leopards, monkeys, and over 250 species of birds, along with a toy train, boating lake, and nature trails. The Kanheri Caves within the park—dating from 1st century BCE to 10th century CE—are a group of over 100 Buddhist rock-cut monasteries and prayer halls. The combination of spirituality, wildlife, and open space makes it one of Mumbai’s most unique destinations."
  }
],

  "services": [
    {
      "name": "Alandi to Mumbai Cab Booking",
      "description": "Book your cab from Alandi to Mumbai with ease and convenience. Our seamless online booking system offers instant confirmation, flexible payment options, and round-the-clock customer support for a hassle-free experience."
    },
    {
      "name": "One Way Taxi Alandi to Mumbai",
      "description": "Opt for our reliable one-way taxi service from Alandi to Mumbai, perfect for direct, point-to-point travel. Enjoy comfortable rides with professional drivers ensuring timely pickups and safe journeys."
    },
    {
      "name": "Round Trip Cab Alandi to Mumbai",
      "description": "Plan your return journey with our round trip cab service from Alandi to Mumbai. Ideal for business travelers and tourists who need a flexible schedule with guaranteed availability both ways."
    },
    {
      "name": "Online Booking Taxi Alandi to Mumbai",
      "description": "Easily book your taxi online from Alandi to Mumbai anytime. Our secure platform ensures fast, transparent booking and lets you choose from a variety of vehicle options tailored to your travel needs."
    },
    {
      "name": "Budget Cab Alandi to Mumbai",
      "description": "Travel economically with our budget-friendly cabs from Alandi to Mumbai. Enjoy clean, well-maintained vehicles and professional service without stretching your budget."
    },
    {
      "name": "SUV Cabs Alandi to Mumbai",
      "description": "Choose spacious and powerful SUV cabs for your Alandi to Mumbai trip. Perfect for group travel or those needing extra luggage space, our SUVs combine comfort with performance on the highway."
    },
    {
      "name": "AC Sedan Hire Alandi to Mumbai",
      "description": "Hire an air-conditioned sedan for a smooth and comfortable ride from Alandi to Mumbai. Ideal for business or leisure travel, our sedans come equipped with modern amenities and experienced chauffeurs."
    },
    {
      "name": "Private Taxi Alandi to Mumbai",
      "description": "Enjoy the privacy and convenience of a private taxi from Alandi to Mumbai. Customize your travel schedule without any stops or shared rides, ensuring a personal and stress-free experience."
    },
    {
      "name": "Chauffeur Driven Cab Alandi to Mumbai",
      "description": "Experience professional chauffeur-driven cabs from Alandi to Mumbai. Our courteous and well-trained drivers prioritize your safety, comfort, and timely arrival at your destination."
    },
    {
      "name": "Corporate Cab Alandi to Mumbai",
      "description": "Efficient and premium corporate cab services for business travelers commuting between Alandi and Mumbai. Punctual pickups, professional service, and well-maintained vehicles to support your business needs."
    },
    {
      "name": "Reliable Travel Cab Alandi to Mumbai",
      "description": "Count on our reliable cab service for consistent, on-time travel from Alandi to Mumbai. We focus on vehicle upkeep and driver training to ensure a safe and comfortable journey every time."
    },
    {
      "name": "Fast Booking Alandi to Mumbai Taxi",
      "description": "Need a taxi quickly? Our fast booking service guarantees immediate cab allocation from Alandi to Mumbai, reducing wait times and ensuring prompt service whenever you need it."
    },
    {
      "name": "Family Cab Alandi to Mumbai",
      "description": "Family-friendly cabs equipped with ample space and safety features for your trip from Alandi to Mumbai. Travel comfortably with your loved ones, whether it’s a weekend getaway or a family event."
    },
    {
      "name": "24/7 Cab Alandi to Mumbai",
      "description": "Our 24/7 taxi service from Alandi to Mumbai is available anytime, day or night. Perfect for late arrivals, early departures, or urgent travel needs, ensuring you’re never left waiting."
    },
    {
      "name": "Affordable Fare Taxi Alandi to Mumbai",
      "description": "Get transparent and affordable fare options for your taxi ride from Alandi to Mumbai. We provide competitive pricing without compromising service quality, making your trip cost-effective and comfortable."
    }
  ],
  "tableData": [
    ["Alandi to Mumbai Cab Booking", "One Way Taxi Alandi to Mumbai"],
    ["Round Trip Cab Alandi to Mumbai", "Online Booking Taxi Alandi to Mumbai"],
    ["Budget Cab Alandi to Mumbai", "SUV Cabs Alandi to Mumbai"],
    ["AC Sedan Hire Alandi to Mumbai", "Private Taxi Alandi to Mumbai"],
    ["Chauffeur Driven Cab Alandi to Mumbai", "Corporate Cab Alandi to Mumbai"],
    ["Reliable Travel Cab Alandi to Mumbai", "Fast Booking Alandi to Mumbai Taxi"],
    ["Family Cab Alandi to Mumbai", "24/7 Cab Alandi to Mumbai"],
    ["Affordable Fare Taxi Alandi to Mumbai", ""]
  ],




"whychoose": [
    {
        "WhyChooseheading": "Reliable Alandi to Mumbai Cab Service for Smooth Travel",
        "WhyChoosedescription": "Our Alandi to Mumbai cab service ensures timely pickups and comfortable rides, whether you’re traveling for business, leisure, or airport transfers. We prioritize your convenience and safety for a hassle-free journey every time."
    },
    {
        "WhyChooseheading": "Clean, Comfortable, and Well-Maintained Vehicles",
        "WhyChoosedescription": "Travel in our air-conditioned, spacious, and regularly sanitized vehicles. Our fleet is carefully maintained to provide a pleasant and safe environment, ensuring a comfortable journey from Alandi to Mumbai."
    },
    {
        "WhyChooseheading": "Professional and Experienced Drivers",
        "WhyChoosedescription": "Our drivers are courteous, background-verified, and trained to handle the best routes from Alandi to Mumbai. They ensure safe driving, punctual pickups, and a friendly travel experience, making your journey smooth and enjoyable."
    },
    {
        "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
        "WhyChoosedescription": "We offer upfront and competitive pricing inclusive of fuel, tolls, taxes, and driver allowances. Our transparent pricing policy guarantees no surprises, allowing you to plan your travel budget with confidence."
    },
    {
        "WhyChooseheading": "Flexible Booking Options to Suit Your Schedule",
        "WhyChoosedescription": "Whether you need a one-way trip, round trip, or hourly rental, we provide customizable booking options tailored to your travel plans. Choose your preferred pickup and drop-off points anywhere in Alandi and Mumbai for maximum convenience."
    },
    {
        "WhyChooseheading": "Door-to-Door Pickup and Drop-off Service",
        "WhyChoosedescription": "Enjoy the ease of door-to-door service with pickups and drop-offs at your exact locations in Alandi and Mumbai. This service saves you time and effort, providing a seamless travel experience."
    },
    {
        "WhyChooseheading": "Ideal for Airport Transfers, Corporate Travel, and Family Trips",
        "WhyChoosedescription": "Our cabs are perfect for all kinds of travel, including airport transfers, business meetings, and family outings. Experience dependable, comfortable, and professional service on every journey."
    },
    {
        "WhyChooseheading": "24/7 Customer Support and Easy Online Booking",
        "WhyChoosedescription": "Our customer support team is available round the clock to help with bookings, cancellations, and special requests. Book your Alandi to Mumbai cab anytime through our simple and convenient online platform."
    }
]























    }

const faqData = [
    {
        question: "How do I book a cab from Alandi to Mumbai?",
        answer: "Booking is easy—call Meghana Cab at +91 9075462128 or visit our website for instant online reservations."
    },
    {
        question: "What is the estimated travel time from Alandi to Mumbai by cab?",
        answer: "The journey typically takes around 3.5 to 4.5 hours depending on traffic and the exact drop location in Mumbai."
    },
    {
        question: "Are one way and round trip options available from Alandi to Mumbai?",
        answer: "Yes, we provide both one way and round trip cab services as per your travel needs."
    },
    {
        question: "What types of cabs are available for this route?",
        answer: "We offer a range of vehicles including hatchbacks, sedans, Ertiga, SUVs, Innova Crysta, and tempo travellers."
    },
    {
        question: "Is the cab service from Alandi to Mumbai available 24/7?",
        answer: "Yes, Meghana Cab operates 24/7 to ensure your travel is convenient at any hour."
    },
    {
        question: "What’s included in the fare for Alandi to Mumbai cabs?",
        answer: "Our cab fare includes fuel, tolls, and driver charges. Parking fees or waiting time may be extra if applicable."
    },
    {
        question: "Can I request stops for meals or sightseeing during the trip?",
        answer: "Yes, you can request planned stopovers. Just let us know while booking or inform the driver."
    },
    {
        question: "Can I book a cab from Alandi to Mumbai at the last minute?",
        answer: "Yes, we do accept urgent and last-minute bookings based on vehicle availability. Call us for faster processing."
    },
    {
        question: "Is online booking and payment available?",
        answer: "Yes, you can book and pay securely online using UPI, credit/debit cards, net banking, or cash."
    },
    {
        question: "Are your drivers experienced and route-verified?",
        answer: "Absolutely. Our drivers are trained, background-verified, and familiar with the Alandi to Mumbai route."
    },
];

const testimonialsData = [
    {
        name: 'Mr. Ramesh Jagtap',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“Booked a cab from Alandi to Mumbai for a family function. Very professional service and on-time pickup!”',
    },
    {
        name: 'Ms. Neha Dighe',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“Clean car, smooth ride, and polite driver. Great experience with Meghana Cab from Alandi to Mumbai.”',
    },
];
































































































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9075462128",
            "+91 8452916550",

        ],
        email: "booking@meghanacabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Online Cab Booking in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Kolhapur Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Satara Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Hyderabad Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune to Bangalore Cab",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Pune to Indore Cab",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Gujarat Cab",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Lonavala Taxi",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Pune to Jejuri Cab",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Local Taxi Service in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pune to Lavasa Cab",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Pune to Kashid Beach Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "One Way Cab Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Round Trip Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Taxi Service Near Me",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Car Hire in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Seater Car on Rent in Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Cab Service in Pimpri Chinchwad",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune Taxi Cab Services",
        },
        {
            place: "/images/keyword/20.jpg",
            text: "Pune Airport Taxi",
        },

        {
            place: "/images/keyword/21.jpg",
            text: "Pune to Rajasthan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Pune to Matheran Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Pandharpur Cab",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Mumbai Cabs",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Pune to Mumbai Airport Cab ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to Mumbai Taxi",
        },
    ];


    const images = [
        { src: "/images/booking/1.jpg", alt: "Image 1" },
        { src: "/images/booking/5.jpg", alt: "Image 1" },
        { src: "/images/booking/2.jpg", alt: "Image 1" },
        { src: "/images/booking/3.jpg", alt: "Image 1" },
        { src: "/images/booking/4.jpg", alt: "Image 1" },
        { src: "/images/booking/7.jpg", alt: "Image 1" },
        { src: "/images/booking/8.jpg", alt: "Image 1" },
        { src: "/images/booking/9.jpg", alt: "Image 1" },
        { src: "/images/booking/6.jpg", alt: "Image 1" },

    ];






const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Alandi to Mumbai Cabs Service",
  "image": "https://www.meghanacabs.com/assets/images/alandi-to-mumbai-cab.jpg",
  "description": "Book reliable and affordable cab service from Alandi to Mumbai with Meghana Cabs. Choose from budget, SUV, AC sedan, and chauffeur-driven taxis for one-way and round trips. Family and corporate travel options available. 24/7 online booking.",
  "brand": {
    "@type": "Brand",
    "name": "Meghana Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "5213"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1900",
    "availability": "https://schema.org/InStock",
    "url": "https://www.meghanacabs.com/alandi-to-mumbai-cabs-service"
  }
};










    return (
        <div>

<Helmet>
  <title>Alandi to Mumbai Cabs Service | Meghana Cabs</title>
  <meta 
    name="description" 
    content="Book reliable and affordable cab service from Alandi to Mumbai with Meghana Cabs. Choose from budget, SUV, AC sedan, and chauffeur-driven taxis for one-way and round trips. Family and corporate travel options available. 24/7 online booking." 
  />
  <meta 
    name="keywords" 
    content="Alandi to Mumbai Cab Booking, One Way Taxi Alandi to Mumbai, Round Trip Cab Alandi to Mumbai, Online Booking Taxi Alandi to Mumbai, Budget Cab Alandi to Mumbai, SUV Cabs Alandi to Mumbai, AC Sedan Hire Alandi to Mumbai, Private Taxi Alandi to Mumbai, Chauffeur Driven Cab Alandi to Mumbai, Corporate Cab Alandi to Mumbai, Reliable Travel Cab Alandi to Mumbai, Fast Booking Alandi to Mumbai Taxi, Family Cab Alandi to Mumbai, 24/7 Cab Alandi to Mumbai, Affordable Fare Taxi Alandi to Mumbai" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <section className="page-title centred">
                <div className="bg-layer" style={{ backgroundImage: 'url(/images/page-header-bg.jpg)' }}></div>
                <div className="auto-container">
                    <div className="content-box">

                        <h1>{cardData.keyword}</h1>
                    </div>
                </div>
            </section>




            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/Keywords/58.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#F2614C', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3 text-dark'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Meghana Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <Accordion data={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3 className=' text-dark'>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F1604F',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F1604F' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919075462128" className="d-block  text-white">+91 9075462128</a>
                                                <a href="tel:+918452916550" className="d-block  text-white">+91 8452916550</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@meghanacabs.com" className=" text-white d-block">
                                                    booking@meghanacabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Meghana Cab  <br />
                                                        Yelwande Wasti. Opp Vithal Lawans, Laxmi Chowk, Hinjawadi, Pune - 411057
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Alanditomumbaicabservice;